export function haversine_distance(loc1, loc2) {
		var R = 3958.8; // Radius of the Earth in miles
		var rlat1 = loc1.lat * (Math.PI/180); // Convert degrees to radians
		var rlat2 = loc2.lat * (Math.PI/180); // Convert degrees to radians
		var difflat = rlat2-rlat1; // Radian difference (latitudes)
		var difflon = (loc2.lng - loc1.lng) * (Math.PI/180); // Radian difference (longitudes)

		var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
		return d;
}

export function isTouch() {
		try {
				document.createEvent("TouchEvent");
				return true;
		} catch (e) {
				return false;
		}
}
